// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "servicePrice-Srw60";
var _5 = "additionalServices-3vEIz";
var _6 = "upgrade-12y8W";
var _7 = "insurancePage-xNW_X";
var _8 = "extras-3lvr1";
var _9 = "wrapper-2XPRJ";
var _a = "seats-2XCwN";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "servicePrice", _5 as "additionalServices", _6 as "upgrade", _7 as "insurancePage", _8 as "extras", _9 as "wrapper", _a as "seats" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "servicePrice": _4, "additionalServices": _5, "upgrade": _6, "insurancePage": _7, "extras": _8, "wrapper": _9, "seats": _a }
